<mat-checkbox
  [id]="id + '-checkbox'"
  [(ngModel)]="checked"
  (ngModelChange)="checkChanged($event)"
  [disabled]="disabled"
  name="checkbox"
  [disableRipple]="true"
>
  <span [innerHTML]="titleSafeHtml"></span>
</mat-checkbox>
